module.exports = __webpack_public_path__ + "static/media/color_classification.f69a82f6.jpg";